import React, { PureComponent } from "react";
import PropTypes from "prop-types";

class EmptyCard extends PureComponent {
	render() {
		const { text, height } = this.props;

		return (
			<div className={`card card-empty-state card-dashed height-${height}`}>
				<div className="text-center">
					<i className="rkf rkf-file-image rkf-4x" />
					<p className="margin-top-12">{text}</p>
				</div>
			</div>
		);
	}
}

EmptyCard.propTypes = {
	text: PropTypes.string,
	height: PropTypes.number,
};

EmptyCard.defaultProps = {
	text: "There is nothing to display",
	height: 200,
};

export default EmptyCard;
